/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChartPpf = createReactComponent("chart-ppf", "IconChartPpf", [
  ["path", { d: "M19 17c0 -6.075 -5.373 -11 -12 -11", key: "svg-0" }],
  ["path", { d: "M3 3v18h18", key: "svg-1" }]
]);

export { IconChartPpf as default };
//# sourceMappingURL=IconChartPpf.js.map
